
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth, GoogleAuthProvider, signInWithPopup, onAuthStateChanged, signOut, setPersistence, browserSessionPersistence } from 'firebase/auth'
import { getFirestore, collection, doc, setDoc, getDoc, addDoc, updateDoc } from "firebase/firestore"; 

const firebaseConfig = {
  apiKey: "AIzaSyAQze4wg86B97wcgs4KdJFJXFl8lEW-D4M",
  authDomain: "hackathon-d67fc.firebaseapp.com",
  projectId: "hackathon-d67fc",
  storageBucket: "hackathon-d67fc.appspot.com",
  messagingSenderId: "991930280735",
  appId: "1:991930280735:web:02de661bc5250dab435e2a",
  measurementId: "G-06MW21G601"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
export { updateDoc, getDoc, addDoc, doc, collection, db, setDoc, signInWithPopup, GoogleAuthProvider, onAuthStateChanged, signOut}